<div class="fiscal-code-panel">
  <div class="fiscal-code-panel-header">
    <span
      >Per poter procedere con il pagamento, sono necessarie le seguenti
      informazioni</span
    >
  </div>
  <form [formGroup]="fiscalForm" (ngSubmit)="onSubmit()" class="fiscal-form">
    <div class="form-group">
      <label for="first_name">Nome</label>
      <input
        id="first_name"
        type="text"
        formControlName="first_name"
        class="form-control"
        [class.is-invalid]="
          fiscalForm.get('first_name')?.invalid &&
          fiscalForm.get('first_name')?.touched
        "
      />
      @if (
        fiscalForm.get("first_name")?.invalid &&
        fiscalForm.get("first_name")?.touched
      ) {
        <div class="invalid-feedback">Il nome è obbligatorio</div>
      }
    </div>

    <div class="form-group">
      <label for="last_name">Cognome</label>
      <input
        id="last_name"
        type="text"
        formControlName="last_name"
        class="form-control"
        [class.is-invalid]="
          fiscalForm.get('last_name')?.invalid &&
          fiscalForm.get('last_name')?.touched
        "
      />
      @if (
        fiscalForm.get("last_name")?.invalid &&
        fiscalForm.get("last_name")?.touched
      ) {
        <div class="invalid-feedback">Il cognome è obbligatorio</div>
      }
    </div>

    <div class="form-group">
      <label for="fiscal_code">Codice Fiscale</label>
      <input
        id="fiscal_code"
        type="text"
        formControlName="fiscal_code"
        class="form-control"
        maxlength="16"
        [class.is-invalid]="
          fiscalForm.get('fiscal_code')?.invalid &&
          fiscalForm.get('fiscal_code')?.touched
        "
      />
      @if (
        fiscalForm.get("fiscal_code")?.invalid &&
        fiscalForm.get("fiscal_code")?.touched
      ) {
        <div class="invalid-feedback">
          @if (fiscalForm.get("fiscal_code")?.errors?.["required"]) {
            <span> Il codice fiscale è obbligatorio </span>
          }
          @if (
            fiscalForm.get("fiscal_code")?.errors?.["minlength"] ||
            fiscalForm.get("fiscal_code")?.errors?.["maxlength"]
          ) {
            <span> Il codice fiscale deve essere di 16 caratteri </span>
          }
          @if (fiscalForm.get("fiscal_code")?.errors?.["invalidFormat"]) {
            <span> Il formato del codice fiscale non è valido </span>
          }
        </div>
      }
    </div>

    <button
      type="submit"
      class="submit-button"
      [disabled]="fiscalForm.invalid || isLoading"
    >
      @if (isLoading) {
        <mat-spinner diameter="20" class="spinner"></mat-spinner>
      }
      <span [class.hidden]="isLoading">Continua per il pagamento</span>
    </button>
  </form>
</div>
